module.exports = __webpack_public_path__ + "img/coupon-box.1641ab96.png";